import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import { HdsAlert } from '@hashicorp/design-system-components/components';

import boxPadding from '../../modifiers/box-padding.ts';
import boxMargin from '../../modifiers/box-margin.ts';

import type { HdsAlertSignature } from '@hashicorp/design-system-components/components/hds/alert/index';
import type FlashMessageService from 'ember-cli-flash/services/flash-messages';
import type EnginesRouterService from 'ember-engines-router-service/services/router';
import type UserContextService from '../../services/user-context.ts';

interface SystemNotificationsScimPrivateBetaSignature {
  Args: {
    flash: {
      id: string;
      color: HdsAlertSignature['Args']['color'];
      icon: HdsAlertSignature['Args']['icon'];
      message: string;
      content: string;
      context: {
        providers: string[];
      };
    };
  };

  Blocks: {
    default: [];
  };

  Element: HdsAlertSignature['Element'];
}

export default class SystemNotificationsScimPrivateBeta extends Component<SystemNotificationsScimPrivateBetaSignature> {
  @service declare readonly flashMessages: FlashMessageService;
  @service declare readonly userContext: UserContextService;
  @service declare readonly router: EnginesRouterService;

  SETTINGS_DETAILS_SCIM_ROUTE = 'cloud.orgs.detail.settings.scim';

  get activeRoute() {
    return this.router.currentRouteName;
  }

  <template>
    {{#if (eq this.activeRoute this.SETTINGS_DETAILS_SCIM_ROUTE)}}
      <HdsAlert
        @color={{@flash.color}}
        @icon={{@flash.icon}}
        @type="page"
        data-test-system-notification={{@flash.id}}
        ...attributes
        as |A|
      >
        <A.Title>
          {{t @flash.message}}
        </A.Title>
        <A.Description>
          {{t @flash.content}}
        </A.Description>
        <A.Description>
          <ul
            data-test-system-notification-provider
            {{boxMargin "0 0 0 0"}}
            {{boxPadding "3xs 0 0 lg"}}
          >
            {{#each @flash.context.providers as |provider|}}
              <li>{{provider}}</li>
            {{/each}}
          </ul>
        </A.Description>
      </HdsAlert>
    {{/if}}
  </template>
}
